export default __webpack_public_path__ + "static/cafe_36088-a2a6eba4fbd481d6f89420d132fe5d3c.png";